export const BUSINESS_PRODUCTS = 'publicWeb/businessProducts/transition/';
export const GET_BUSINESS_PRODUCTS = BUSINESS_PRODUCTS + 'getbusinessProducts';
export const RECEIVED_BUSINESS_PRODUCTS = BUSINESS_PRODUCTS + 'receivedbusinessProducts';
export const BUSINESS_PRODUCTS_PARAMS_SET_VALUE = BUSINESS_PRODUCTS + 'setbusinessProductsParams';
export const RECEIVED_BUSINESS_PRODUCTS_MAP = BUSINESS_PRODUCTS + 'mapReceivedBusinessProducts';

export const fetchBusinessProducts = () => ({ type: GET_BUSINESS_PRODUCTS });
export const setParams = value => ({ type: BUSINESS_PRODUCTS_PARAMS_SET_VALUE, value });
export const mapReceivedBusinessProducts = value => ({ type: RECEIVED_BUSINESS_PRODUCTS_MAP, value });